/* eslint-disable no-case-declarations */
// Use relative imports instead of barrel to avoid circular dependency
// (the barrel's first export is this very module)
import { APIClient } from './api-client';
import { authenticator } from '../app-core/setup/authenticator';
import { axiosBaseInstance } from '../app-core/setup/axios-api';
import { signer } from '../app-core/setup/signer';

import { auth0Signer } from '../app-core/setup/auth0-signer';
import { auth0Authenticator } from '../app-core/setup/auth0-authenticator';

export enum ApiClientType {
  Aws = 'aws',
  Auth0 = 'auth0'
}

export class APIClients {
  private static baseAPIClient: APIClient | undefined;

  public static setApiClient(apiClientType: ApiClientType): void {
    switch (apiClientType) {
      case ApiClientType.Aws:
        APIClients.baseAPIClient = new APIClient(axiosBaseInstance, signer, authenticator);
        break;
      case ApiClientType.Auth0:
        APIClients.baseAPIClient = new APIClient(axiosBaseInstance, auth0Signer, auth0Authenticator);
        break;
      default:
        throw new Error('Unsupported auth type');
    }
  }

  public static getAPIClient(): APIClient {
    if (!APIClients.baseAPIClient) {
      throw new Error('API client has not been set. Call setApiClient first.');
    }

    return APIClients.baseAPIClient;
  }
}
